import { CustomAsyncSelect } from "components/Common/Common";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { FieldArray, useFormikContext } from "formik";
import useModal from "hooks/useModal";
import React, { memo, useEffect, useRef, useState } from "react";
import { useLazyGetStartegyTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";
import threDots_img from "Assets/images/three-dots.png"
import { Accordion, Col, Dropdown, Row } from "react-bootstrap";
import SaveStrategyTemplatePop from "components/Modals/SaveStrategyTemplatePop";
import { cloneDeep, isEmpty } from "lodash";
import { promiseToast } from "helpers/common";
import { GOAL_TRACK_PARAMETERS_COLORS_V2, GOAL_TRACK_PARAMETERS_V2, MAX_REPORT_ASSESSMENTS, reportDateFormat, TASK_PLAN_SESSION_COLOR_V2, } from "config/constants";
import confirmDialogV2 from "utils/confirmationDialogV2";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useGetGoalStatusListQuery } from "store/services/utility";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { components } from "react-select";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { STRATEGY_OPTIONS } from "config/constants";
import StrategiesTemplatesPop from "components/Modals/StrategyTemplatesPop";
import AddTreatmentPop from "../Modals/AddTreatmentArea";
import SessionTrackingButton from "../TaskPlanSessions/SessionTrackingButton";
import TreatmentGoalTrackChart from "../TreatmentGoalTracking/TreatmentGoalTrackChart";
import EditGoalDetailPop from "../GoalsTracking/components/Modals/EditGoalDetail";
import { useDeleteGoalMutation } from "store/services/clients/assessmentTreatmentPlan/goals/manageGoals";

const QuestionTreatmentSummary = ({ fieldName, question, fieldData, previewMode, clientType, assessmentId, therapist, max, maxRecommendations, assessmentAssignedId, refetchData, dataFetching, reportGoals, maxStrategy, chartRefs, handleSubmit, ...props }) => {
    const { setFieldValue, values, touched, errors, setFieldTouched } = useFormikContext();
    const [activeKey, setActiveKey] = useState(0);
    const { show: showGoalPopup, data: goalPopupData, open: openGoalPopup, close: closeGoalPopup } = useModal();
    const { show: showEditGoalModal, data: editGoalData, open: openEditGoalModal, close: closeEditGoalModal } = useModal(null);

    const [deleteGoal, { isLoading: deleteGoalLoading }] = useDeleteGoalMutation()
    const { data: goalStatusList, isLoading: goalStatusListLoading } = useGetGoalStatusListQuery({})
    const notAllowed = ['Pending', 'Complete']
    const goalStatusListOptions = goalStatusList?.length > 0 ? goalStatusList?.map(status => ({ label: status.title, value: status.id }))?.filter((x) => !notAllowed?.includes(x?.label)) : []
    console.log("GOAL STATUS OPTIONS ", goalStatusListOptions)

    const [getTemplates, { isFetching }] = useLazyGetStartegyTemplatesQuery();

    const getTemplateOptions = async (search) => {
        try {
            const data = await getTemplates({ assessmentId, search, clientType, status: "" }).unwrap();
            const templates = data?.records || [];
            return templates?.map(i => ({
                label: i.title,
                value: i,
                // tags: i.StrategyTemplateTagsMapping
                //     ?.map(tag => tag?.strategyTemplateTags?.name)
                //     .filter(Boolean) || []
            }))
        } catch (error) {
            console.log("Error Getting template options", error);
        };
    };

    const SingleObservation = memo(({ index, observation, remove, push }) => {
        const [showDropdown, setShowDropdown] = useState(null);
        const dropdownRef = useRef(null);


        // Dropdown toggle handler
        const toggleDropdown = (e, index) => {
            e.stopPropagation();
            setShowDropdown(showDropdown === index ? null : index);
        };

        const handleDeleteObservation = async (e, index, remove) => {
            // setFieldValue('saveForLater', true)
            // setFieldValue('saveForDelete', true)
            e.stopPropagation();
            const isConfirm = await confirmDialogV2({
                title: "DELETE GOAL",
                message: "Are you sure you want to DELETE this goal from your consultation?",
            });
            if (!isConfirm) {
                return;
            }
            try {
                const data = cloneDeep(values)
                data.saveForLater = true
                data.notSavedFromButton = true

                if (handleSubmit && typeof handleSubmit == "function") {
                    await handleSubmit(data);
                    setFieldValue('notSavedFromButton', false)
                }
                await remove(observation?.id);
            } catch (error) {
                console.log('error', error)
            }
            setFieldTouched(fieldName, true);
        }


        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setShowDropdown(null);
                }
            };

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, []);
        return (
            <>
                <div style={{ padding: "10px 0px 10px 18px", width: "100%" }}>
                    <div className="d-flex gap-2">
                        <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center' style={{ borderBottom: "1px solid #315D99" }}>
                            <div className='proxima-regular' style={{ fontWeight: 700, color: "#315D99", fontSize: "14px" }}>
                                <span>AREA </span>{index + 1}
                            </div>
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
                                <AppDatePicker className="w-100 py-2" name={`${fieldName}.${index}.goal_date`} />

                            </div>
                            <div ref={dropdownRef} className="cstm-dropdownclass">
                                <Dropdown show={showDropdown === index}>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        <img onClick={(e) => toggleDropdown(e, index)} width={19} height={18} src={threDots_img} alt="threDots_img" />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={(e) => { e.stopPropagation(); openEditGoalModal({ index, data: observation }) }}>Edit Goal</Dropdown.Item>
                                        <Dropdown.Item onClick={(e) => { handleDeleteObservation(e, index, remove) }}>Delete Goal</Dropdown.Item>
                                        <Dropdown.Item disabled={values[fieldName]?.[index]?.show_tracker == 'show'} onClick={(e) => { e.stopPropagation(); setFieldValue(`${fieldName}.${index}.show_tracker`, "show") }}>Add Tracker</Dropdown.Item>
                                        <Dropdown.Item disabled={values[fieldName]?.[index]?.show_tracker == 'hidden'} onClick={(e) => { e.stopPropagation(); setFieldValue(`${fieldName}.${index}.show_tracker`, "hidden") }}>Remove Tracker</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ borderTop: "0.75px solid #315D99", marginLeft: "18px" }}></div> */}
                    <div style={{ padding: "14px 0px 14px 3px" }}>
                        <div className="">
                            <Row className="align-items-center">
                                <Col md="2" className="">
                                    <label className="discharge-screen-label mb-0 mt-0" style={{ whiteSpace: "nowrap", color: "#071E3E" }}>AREA:</label>
                                </Col>
                                <Col lg="10">
                                    <p style={{ color: "#071E3E", fontSize: "15px" }} className="m-0">{observation?.assesmentGoalDisciplineArea?.name}</p>
                                </Col>
                            </Row>
                        </div>
                        <div className="mt-3">
                            <Row className="align-items-center">
                                <Col md="2" className="">
                                    <label className="discharge-screen-label mb-0 mt-0" style={{ whiteSpace: "nowrap" }}>GOAL:</label>
                                </Col>
                                <Col lg="10">
                                    <p style={{ color: "#071E3E", fontSize: "15px" }} className="m-0">{observation?.assesmentGoalDetail?.title}</p>
                                </Col>
                            </Row>
                        </div>
                        <div className="mt-3">
                            <Row className="align-items-center">
                                <Col md="2" className="">
                                    <label className="discharge-screen-label mb-0 mt-0" style={{ whiteSpace: "nowrap" }}>DETAIL:</label>
                                </Col>
                                <Col lg="10">
                                    <div className="d-flex align-items-center gap-2">
                                        <p style={{ color: "#071E3E", fontSize: "15px" }} className="m-0">{values?.[`${fieldName}`]?.[`${index}`]?.goal_description || "--"} </p>
                                        {/* <Edit size={16} onClick={(e) => { e.stopPropagation();openEditGoalModal({ index, data: observation }) }} style={{ cursor: "pointer" }} /> */}
                                    </div>
                                    {/* <div
                                        onClick={(e) => e.stopPropagation()}
                                        onMouseDown={(e) => e.stopPropagation()}  // Add this
                                    >
                                        <AppInputField
                                            name={`${fieldName}.${index}.goal_description`}
                                            placeholder="Enter Goal Description"
                                            className="readonly-input"
                                        />
                                    </div> */}
                                </Col>
                            </Row>
                        </div>
                        <div className="mt-3">
                            <Row className="align-items-center">
                                <Col md="2" className="">
                                    <label className="discharge-screen-label mb-0 mt-0" style={{ whiteSpace: "nowrap" }}>STATUS:</label>
                                </Col>
                                <Col lg="3">
                                    <div onClick={(e) => e.stopPropagation()}>
                                        <AppSelect2Field
                                            name={`${fieldName}.${index}.status`}
                                            placeholder="Choose a Goal"
                                            classNamePrefix={"khan"}
                                            option={goalStatusListOptions}
                                            isLoading={goalStatusListLoading}
                                        // onChange={(selected) => {
                                        //   setFieldValue(`${fieldName}?.${index}?.status`, selected);
                                        // }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </>
        )
    })

    const handleRemoveGoal = async (goalId) => {
        try {
            await promiseToast(
                deleteGoal({ goalId, clientType }).unwrap(),
                { toastId: "removeGoal" }
            );
            await refetchData();
        } catch (err) {
            console.error("Error removing goal", err);
        }
    }

    return (
        <div>
            {
                (deleteGoalLoading) && <LoadingOverlay />
            }
            <AddTreatmentPop
                showPopup={showGoalPopup}
                closePopup={closeGoalPopup}
                refetchData={refetchData}
                handleSubmitReport={handleSubmit}
            />

            <EditGoalDetailPop
                refetchData={refetchData}
                index={editGoalData?.index}
                goalValue={editGoalData?.goalValue}
                showPopup={showEditGoalModal}
                closePopup={closeEditGoalModal}
                handleSubmitReport={handleSubmit}
                // You can also pass the observation data if needed
                data={editGoalData?.data}
            />

            <div className="goals goals-accordion assessment-report" style={{ borderBottom: "0.75px solid #315D99", paddingBottom: "28px" }}>
                <Accordion onClick={(e) => e.stopPropagation()} activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                    {reportGoals?.map((observation, index) => (
                        <>
                            <div style={{ position: 'absolute', left: '-9999px', top: 0, zIndex: 999999999999 }}>
                                <TreatmentGoalTrackChart
                                    trackingData={values?.goals?.[index]?.scores || []}
                                    ref={(el) => {
                                        if (el && chartRefs.current) {
                                            console.log(`Assigning ref for index ${index}:`, el);
                                            chartRefs.current[index] = el;
                                        }
                                    }}
                                    version={2}
                                    isSessionTrail={values.goals?.[index]?.is_trails}
                                />
                            </div>
                            <React.Fragment key={index}>
                                <Accordion.Item className="border-0 mb-3" eventKey={index}>
                                    <Accordion.Header>
                                        <SingleObservation
                                            index={index}
                                            push={{}}
                                            remove={handleRemoveGoal}
                                            observation={observation}
                                        />
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        {
                                            values[fieldName]?.[index]?.show_tracker == "show" && (
                                                <Row>
                                                    <Col xs="4" className="">
                                                        <div className="cardCstm rounded-3">
                                                            <div className="contentBody">
                                                                <Row>
                                                                    <Col lg="12" className="my-2">
                                                                        <TreatmentGoalTrackChart
                                                                            trackingData={values?.goals?.[index]?.scores || []}
                                                                            // chartRef={(el) => (chartRefs.current[index] = el)}
                                                                            version={2}
                                                                            isSessionTrail={values.goals?.[index]?.is_trails}
                                                                        />
                                                                    </Col>
                                                                    <Col lg="12" className="my-2">
                                                                        {values?.goals?.[index]?.scores?.length > 0 ? (
                                                                            <ul className="list-unstyled ps-0 mb-0" style={{ maxWidth: "239px" }}>
                                                                                {Object.entries(GOAL_TRACK_PARAMETERS_V2)?.map(([param, label], goalIndex) => {
                                                                                    const color = GOAL_TRACK_PARAMETERS_COLORS_V2[param];
                                                                                    console.log('param, label, index', param, label, index)
                                                                                    // Get the count for this specific parameter (O, P, I)
                                                                                    const paramIndex = Object.keys(GOAL_TRACK_PARAMETERS_V2).indexOf(param);
                                                                                    const count = values?.goals?.[index]?.scores?.[paramIndex] || 0;

                                                                                    // Calculate total sum of all trials
                                                                                    const totalTrials = values?.goals?.[index]?.scores?.reduce((sum, num) => sum + (num || 0), 0) || 0;

                                                                                    // Calculate percentage
                                                                                    const percentage = totalTrials > 0 ? Math.round((count / totalTrials) * 100) : 0;

                                                                                    return (
                                                                                        <li
                                                                                            key={goalIndex}
                                                                                            className="py-1 d-flex align-items-center justify-content-between gap-10"
                                                                                        >
                                                                                            <div className="d-flex align-items-center gap-1">
                                                                                                <div className="d-flex align-items-center gap-2">
                                                                                                    <div style={{ background: color, width: "16px", height: "16px" }}></div>
                                                                                                    <span className="fw-sbold" style={{ width: "25px", fontSize: 11 }}>
                                                                                                        {param}
                                                                                                    </span>{" "}
                                                                                                </div>
                                                                                                <p className="m-0" style={{ fontSize: 11 }}>
                                                                                                    {label}
                                                                                                </p>
                                                                                            </div>
                                                                                            <p className="m-0 d-flex align-items-center gap-2">
                                                                                                <span className="px-2" style={{ fontSize: 11 }}>
                                                                                                    {count}/{totalTrials}
                                                                                                </span>
                                                                                                <span style={{ fontSize: 11, color: "#666" }}>
                                                                                                    ({percentage}%)
                                                                                                </span>
                                                                                            </p>
                                                                                        </li>
                                                                                    );
                                                                                })}
                                                                            </ul>
                                                                        ) : (
                                                                            <p>No trials data available</p>
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col xs="8" className="my-2">
                                                        <div>
                                                            <div className="cardCstm rounded-3">
                                                                <div className="contentBody pb-3">
                                                                    <ul className="list-unstyled ps-0 mb-0">
                                                                        <li className=" ">
                                                                            <Row className="w-100 d-flex">
                                                                                {/* <Col xs={2} style={{ height: "90px" }} className='d-flex align-items-end justify-content-end'>
                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            style={{
                                                                                                width: "24px",
                                                                                                height: "24px",
                                                                                                outline: "none"
                                                                                            }}
                                                                                            disabled={false}
                                                                                            name={`goals.${index}.is_trails`}
                                                                                            checked={values.goals?.[index]?.is_trails || false}
                                                                                            onChange={(e) => {
                                                                                                setFieldValue(`goals.${index}.is_trails`, e.target.checked);
                                                                                            }}
                                                                                        />
                                                                                        <label style={{ fontSize: "12px", marginBottom: 0 }} htmlFor="">N/A</label>
                                                                                    </div>
                                                                                </Col> */}
                                                                                <Col xs={12} className="py-2">
                                                                                    <ul
                                                                                        className={`list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-between position-relative gap-10 ${values.goals?.[index]?.is_trails ? "taskSessionRatingChecked-v2" : "ratingList-v2"}`}
                                                                                        style={{ zIndex: 9 }}
                                                                                    >
                                                                                        {Object.keys(GOAL_TRACK_PARAMETERS_V2).map((element, idx) => {
                                                                                            const color = GOAL_TRACK_PARAMETERS_COLORS_V2[element];
                                                                                            const fieldValue = values?.goals?.[index]?.scores?.[idx];
                                                                                            return (
                                                                                                <li key={element} className="px-2">
                                                                                                    <SessionTrackingButton
                                                                                                        isDisabled={false}
                                                                                                        element={element}
                                                                                                        color={GOAL_TRACK_PARAMETERS_COLORS_V2[element]}
                                                                                                        value={fieldValue}
                                                                                                        isSessionTrail={false}
                                                                                                        onValueChange={(sessionIdx, trackingIdx, elem, val) => {
                                                                                                            const currentTrails = [...(values?.goals?.[index]?.scores || [0, 0, 0])];
                                                                                                            currentTrails[idx] = val ? parseInt(val) : 0;
                                                                                                            setFieldValue(`goals.${index}.scores`, currentTrails);
                                                                                                        }}
                                                                                                        trackingIndex={idx}
                                                                                                    />
                                                                                                </li>
                                                                                            );
                                                                                        })}
                                                                                    </ul>
                                                                                </Col>
                                                                            </Row>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </Col>
                                                    {
                                                        touched.goals?.[index]?.scores && errors.goals?.[index]?.scores && typeof (errors.goals?.[index]?.scores) == "string" ? (
                                                            <div className="text-danger mt-3">{errors.goals?.[index]?.scores}</div>
                                                        ) : null
                                                    }
                                                </Row>
                                            )
                                        }

                                        <h6 className="section-title w-100 mt-4" style={{ marginBottom: "7px", color: "#071E3E" }}>
                                            GOAL PROGRESSION
                                        </h6>
                                        <Row className={`reports-v2-question ${question?.question_type}`}>

                                            <Col lg="4">
                                                <p style={{ fontStyle: "italic", color: "#071E3E" }}>Summarize qualitative and quantitative information on this goal and  indicate strategies that were used during this session. Also provide suggestions on places or contexts where this goal can be targeted. </p>
                                            </Col>

                                            <Col lg={8} className="session-input-radio text-area-report">
                                                <div className="pb-3" style={{ borderBottom: "1px solid #071E3E" }}>
                                                    <CustomEditor style={{ border: "2px solid red" }} name={`${fieldName}.${index}.goal_notes`} />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg='4'>
                                            </Col>
                                            <Col lg='8'>
                                                <FieldArray name={`${fieldName}.${index}.strategy`}>
                                                    {({ push: strategyPush, remove: strategyRemove }) => (
                                                        <>
                                                            {values?.goals?.[index]?.strategy?.map((strategy, strategyIndex) => (
                                                                <React.Fragment key={strategyIndex}>
                                                                    <Col lg="12">
                                                                        <div className="mb-4 mt-2 ">
                                                                            <StrategyForm
                                                                                touched={touched}
                                                                                errors={errors}
                                                                                setFieldTouched={setFieldTouched}
                                                                                question={question}
                                                                                clientType={clientType}
                                                                                strategyIndex={strategyIndex}
                                                                                index={index}
                                                                                setFieldValue={setFieldValue}
                                                                                values={values}
                                                                                outerFieldName={fieldName}
                                                                                assessmentId={assessmentId}
                                                                                fieldName={`${fieldName}.${index}.strategy`}
                                                                                getTemplateOptions={getTemplateOptions}
                                                                                // openModal={open}
                                                                                // close={close}
                                                                                remove={strategyRemove}
                                                                                maxStrategy={maxStrategy}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </React.Fragment>
                                                            ))}
                                                            <Col lg="12">
                                                                <div style={{ borderTop: "0.75px solid #315D99", paddingTop: "13px" }} className="d-flex mt-2 align-items-center gap-3">
                                                                    {
                                                                        (maxStrategy && maxStrategy > values[fieldName]?.[index]?.strategy?.length) &&
                                                                        < button
                                                                            className="blue-discharge-screen-btn mt-0"
                                                                            type="button"
                                                                            onClick={() => strategyPush({
                                                                                answers: "",
                                                                                attachmentData: [],
                                                                            })}
                                                                        >
                                                                            Add Strategy
                                                                        </button>
                                                                    }
                                                                    <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. {maxStrategy} per treatment.</p>
                                                                </div>
                                                                {
                                                                    touched.goals?.[index]?.strategy && errors.goals?.[index]?.strategy && typeof (errors.goals?.[index]?.strategy) == "string" ? (
                                                                        <div className="text-danger mt-3">{errors.goals?.[index]?.strategy}</div>
                                                                    ) : null
                                                                }
                                                            </Col>
                                                        </>
                                                    )}
                                                </FieldArray>
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </React.Fragment>
                        </>

                    ))}
                </Accordion>
            </div>

            <div className="d-flex mt-2 align-items-center gap-3">
                {
                    (max && values[fieldName]?.length < max) &&
                    <button
                        type="button"
                        className="blue-discharge-screen-btn mt-0"
                        disabled={deleteGoalLoading || dataFetching}
                        onClick={() =>
                            // push({
                            //     tracker_percentage: 0,
                            //     notes: "",
                            //     AssessmentGoalStrategyData: [],
                            //     show_tracker: "show"
                            // })
                            openGoalPopup()
                        }
                    >
                        Add a Goal
                    </button>
                }
                <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. {max} per plan.</p>
            </div>


        </div>
    );
};

const StrategyForm = ({ index, strategyIndex, setFieldValue, values, assessmentId, clientType, fieldName, outerFieldName, getTemplateOptions, remove, question, maxStrategy, touched, errors, setFieldTouched }) => {
    const { show, data, open, close } = useModal();
    const { show: showTemplates, data: templatesData, open: templatesOpen, close: templatesClose } = useModal();
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const handleTemplateSelect = (selected) => {
        setSelectedTemplate(selected);
        setFieldValue(`${fieldName}.${strategyIndex}.answers`, selected?.value?.answers || "");
        setFieldValue(`${fieldName}.${strategyIndex}.attachmentData`, values?.[fieldName]?.[strategyIndex]?.attachmentData || []);
        setFieldValue(`${fieldName}.${strategyIndex}.template_id`, selected?.value?.id);
    }

    const handleDeleteStrategy = async (e, stratIndex, remove) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "DELETE STRATEGY",
            message: "Are you sure you want to DELETE this from your consultation?",
        });
        if (!isConfirm) {
            return;
        }
        remove(stratIndex);
        setFieldTouched(fieldName, true)
    }

    const Option = (props) => {
        const { data, isSelected } = props;
        return (
            <components.Option {...props}>
                <div>
                    <div
                        style={{
                            // fontWeight: isSelected ? "bold" : "normal",
                            color: isSelected
                                ? "#fff"
                                : "#212529"
                        }}
                    >
                        {data.label}
                    </div>
                    {data.tags?.length > 0 && (
                        <div className="mt-1 d-flex flex-wrap gap-1">
                            {data.tags.map((tag, idx) => (
                                <div
                                    key={idx}
                                    className="rounded-pill"
                                    style={{
                                        pointerEvents: "none",
                                        fontWeight: "normal",
                                        backgroundColor: "#e8f5fe",
                                        color: "#007bff",
                                        border: "1px solid #007bff",
                                        padding: "1px 5px",
                                        fontSize: "12px"
                                    }}
                                >
                                    {tag}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </components.Option>
        );
    };

    useEffect(() => {
        if (values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.template_id) {
            setSelectedTemplate({ value: values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.template_id, label: values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.title })
        }
    }, [data])

    return (
        <>
            <SaveStrategyTemplatePop
                mainSetFieldValue={setFieldValue}
                outerFieldName={outerFieldName}
                index={index}
                strategyIndex={strategyIndex}
                showPopup={show}
                closePopup={close}
                data={data}
                currentStrategyFieldName={'AssessmentGoalStrategyData'}
                clientType={clientType}
                assessmentId={assessmentId}
            />
            <StrategiesTemplatesPop
                mainSetFieldValue={setFieldValue}
                setSelectedTemplate={setSelectedTemplate}
                outerFieldName={outerFieldName}
                index={index}
                currentStrategyFieldName={'strategy'}
                strategyIndex={strategyIndex}
                showPopup={showTemplates}
                closePopup={templatesClose}
                data={data}
                clientType={clientType}
                assessmentId={assessmentId}
            />
            <Row>
                <Col lg="12">
                    <div style={{ borderBottom: "0.75px solid #000" }} className="d-flex justify-content-between align-items-center">
                        <h6 class="m-0 proxima themeBlue fw-bold text-uppercase" style={{ fontSize: "12px" }}>STRATEGY {strategyIndex + 1}</h6>
                        <div className="cstm-dropdownclass">
                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-basic">
                                    <img width={19} height={18} src={threDots_img} alt="threDots_img" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={(e) => handleDeleteStrategy(e, strategyIndex, remove)}>Delete</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </Col>
                {/* <Col lg="4" className="px-0" style={{ margin: "12px 0" }}>
                    <p style={{ fontStyle: "italic", color: "#071E3E" }}>{question.template}</p>
                </Col> */}
                <Col lg="12" style={{ margin: "12px 0" }}>
                    {
                        values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.answers || values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.strategyRadio == "newStrategy" ?
                            <>
                                {
                                    values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.template_id &&
                                    <div className=" justify-content-between gap-3 align-items-center" style={{ borderBottom: "0.75px solid #000000", padding: "0px 0" }}>
                                        <div className="w-100">
                                            <h6 class=" proxima themeBlue" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "10px" }}>Strategy Template</h6>
                                            <CustomAsyncSelect
                                                cstmOption={Option}
                                                placeholder={"(no template selected)"}
                                                loadOptions={getTemplateOptions}
                                                onChange={handleTemplateSelect}
                                                value={selectedTemplate}
                                                defaultOptions={true}
                                            />
                                        </div>
                                        {/* <p>{values?.[outerFieldName]?.[index]?.AssessmentGoalStrategyData?.[strategyIndex]?.title}</p> */}

                                    </div>
                                }
                                <div className="ck-editor-wrapper my-2">
                                    <CustomEditor
                                        name={`${fieldName}.${strategyIndex}.answers`}
                                        attachmentName={`${fieldName}.${strategyIndex}.attachmentData`}
                                    />
                                </div>
                                {
                                    !values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.template_id &&
                                    <button
                                        className="blue-discharge-screen-btn mt-0"
                                        type="button"
                                        onClick={() => {
                                            open({
                                                // name: values[fieldName][strategyIndex]?.name,
                                                answers: values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.answers,
                                            });
                                        }}
                                    >
                                        Save to Templates
                                    </button>
                                }
                            </>
                            :
                            <div className="session-input-radio text-area-report">

                                <div className="radio-inputs">
                                    <AppRadioField
                                        containerClass={"d-flex align-items-center py-1"}
                                        options={STRATEGY_OPTIONS}
                                        name={`${outerFieldName}.${index}.strategy.${strategyIndex}.strategyRadio`}
                                        labelStyles={{
                                            color: "#071E3E",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Proxima Nova regular",
                                        }}
                                    />
                                    < button
                                        className="blue-discharge-screen-btn mt-3"
                                        type="button"
                                        disabled={!values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.strategyRadio}
                                        onClick={() => {
                                            if (values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.strategyRadio == "new") {
                                                // open({
                                                //     // name: values[fieldName][strategyIndex]?.name,
                                                //     answers: values?.observations?.[index]?.strategy[strategyIndex]?.answers,
                                                // });
                                                setFieldValue(`${outerFieldName}.${index}.strategy.${strategyIndex}.strategyRadio`, "newStrategy")
                                            }
                                            else {
                                                // alert("REACHED", fieldName)
                                                templatesOpen();
                                            }
                                        }}
                                    // onClick={() => strategyPush({
                                    //     answers: "",
                                    //     attachmentData: [],
                                    // })}
                                    >
                                        Continue
                                    </button>
                                    {
                                        touched.goals?.[index]?.strategy && !isEmpty(errors.goals?.[index]?.strategy) ? (
                                            <div className="text-danger mt-3">{"Please add strategy data"}</div>
                                        ) : null
                                    }
                                </div>
                            </div>
                    }
                </Col>

            </Row>
        </>
    )
}

export default QuestionTreatmentSummary;
// test